import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";

export class EmailTokenPasswordInput extends EmailInput
{
  tokenID:string;
  password:string;
}


export class UserChangePasswordRequest extends PHPRequest<PHPAdress,EmailTokenPasswordInput,PHPResponse>
{
  static readonly ADRESS = PHPAdresses.USER_CHANGE_PASSWORD;

  constructor(){ super( UserChangePasswordRequest.ADRESS ); }

}
